import { render, staticRenderFns } from "./voltage.vue?vue&type=template&id=42a0b804&scoped=true"
import script from "./voltage.vue?vue&type=script&lang=js"
export * from "./voltage.vue?vue&type=script&lang=js"
import style0 from "./voltage.vue?vue&type=style&index=0&id=42a0b804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a0b804",
  null
  
)

export default component.exports